import { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectIsAdmin } from 'flow/selectors/own-extension-selectors';
import { routes } from 'flow/types/routes';
import {
    getSlimmedTeamsLandingRoute,
    isSlimmedTeamsApp,
} from 'flow/utils/app-utils';

/**
 * Workaround for admins landing on pbx tab instead of messages tab. This is used since we cannot use a timeout in routes.js,
 * and therefore admin is always undefined in routes.js.
 */
const StartView: FC = () => {
    const history = useHistory();
    const { embedded } = useAppContext();
    const isAdmin = useAppSelector(selectIsAdmin);

    useEffect(() => {
        // Both default landings are tabs the slimmed-down Teams app hides, so it
        // starts on contacts instead - otherwise it opens on a view with no tab.
        if (isSlimmedTeamsApp(embedded)) {
            history.replace(getSlimmedTeamsLandingRoute());
        } else if (isAdmin) {
            history.replace(routes['pbx']);
        } else {
            history.replace(routes['messages']);
        }
    }, []);

    return null;
};

export default StartView;
